import React, { useEffect, useState } from "react";
import PrayerBoard from "../components/PrayerBoard";
import { getToday } from "../api";
import {
  todayMMDDYY,
  weekday,
  todayPretty,
  nowPretty,
  hijriTodayEnglish,
  scheduleMidnightReload,
} from "../utils/date";

export default function FrontDesk() {
  const [data, setData] = useState(null);
  const [now, setNow] = useState(nowPretty());
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // console.log(todayMMDDYY());
  useEffect(() => {
    getToday(todayMMDDYY())
      .then(setData)
      .then(() => setIsLoading(false))
      .catch((e) => {
        setError(e.message);
        setIsLoading(false);
      });
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  if (isLoading) {
    return <div>Loading...</div>; // Render a loading state first
  }

  if (error) {
    return <div>Error Loading</div>; // Render a loading state first
  }
  console.log(data);
  // console.log(data.jumuah);

  // console.log(data.ishaIqamah);
  // console.log(data.ishaIqamah.split(":"));
  return (
    <div>
      <h1>FrontDesk</h1>
      <div className="today-bar">
        <div>
          <strong>Time now:</strong> {now}
        </div>
        <div>
          <strong>Date today:</strong> {todayPretty()}
        </div>
        <div>
          <strong>Weekday:</strong> {weekday()}
        </div>
        <div>
          <strong>Arabic date (Hijri):</strong> {hijriTodayEnglish()}
        </div>
      </div>
      {error && <div className="error">{error}</div>}
      <PrayerBoard data={data} title="Daily Times" />
      <h1>For anything please contact Mehdi Hasan | 845.514.8834</h1>
    </div>
  );
}
